import { useLocation } from "react-router-dom";
import { strings } from "../strings";

interface AccessDeniedState {
  readonly reasonCode?: string;
  readonly operation?: string;
}

/**
 * The 403 page, carrying the reason code every refusal in this system produces (D-114/D-204):
 * "your role does not grant this" is a different message from "your directory account is
 * disabled", and both arrive here as `AUTHZ_*` reason codes on the thrown ApiError.
 */
export function AccessDeniedPage() {
  const location = useLocation();
  const state = (location.state as AccessDeniedState | null) ?? {};

  return (
    <div role="alert" className="eg-error-page">
      <h1>{strings.errors.accessDeniedTitle}</h1>
      <p>{strings.errors.accessDeniedBody}</p>
      {state.reasonCode && (
        <dl>
          <dt>Reason code</dt>
          <dd>{state.reasonCode}</dd>
          {state.operation && (
            <>
              <dt>Operation</dt>
              <dd>{state.operation}</dd>
            </>
          )}
        </dl>
      )}
    </div>
  );
}
